/**
 * This feature's routes, as constants.
 *
 * Two groups, mounted in different applications: the public form belongs to
 * the customer portal, the review screens to the back office. Kept in one file
 * so a screen can link to the other without importing the route table.
 */

export const ONBOARDING_PATHS = {
  requests: "/demandes",
  request: "/demandes/$id",
} as const;

export const ONBOARDING_PUBLIC_PATHS = {
  /** Where the portal's "Créer un compte" points. */
  request: "/ouvrir-un-compte",
} as const;
